var React = require('react');

function Bang5 (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:#FFFFFF;}\n"),React.createElement("path",{"className":"st0","d":"M255.1,501.1c54.3,22.1,119,3.9,153.5-49.8c37.7-58.8,22.4-135.7-40.1-177.1l-32.9,51.3\n\tc32.6,22.2,38.8,62.8,20.4,91.6c-15.2,23.6-44,35-69.2,29.8c-8.1-1.7-16.4-5.2-46.2-24.4l-32.4-20.8L175.4,453l32.4,20.8\n\tC238.8,493.7,247.8,498.1,255.1,501.1","key":1})]);
}

Bang5.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 612 792","style":{"enableBackground":"new 0 0 612 792"},"xmlSpace":"preserve"};

module.exports = Bang5;

Bang5.default = Bang5;
